import { Alert } from 'react-bootstrap';

import { ModalSection } from 'apps/shared/scripts/components';

import messages from './messages.json';
import { alertClassName } from './styles';

const GuestBanner = () => {
  return (
    <ModalSection>
      <Alert className={alertClassName} variant="warning">
        {messages.guestPostWarning}
      </Alert>
    </ModalSection>
  );
};

GuestBanner.displayName = 'GuestBanner';

export default GuestBanner;
